import React, { useContext } from 'react';
// temporarily removing until Raven is further along;
// import { upgradeUser } from '../../store/to-native';
import {
  freeSignUpButtonText,
  freeSignUpSubTitle,
  freeSignUpTitle,
  upgradeButtonText,
  expiredSignUpTitle,
  expiredSignUpSubTitle,
  pausedSignUpSubTitle,
} from '../../i18n/translations';
import classnames from 'classnames';
import './index.scss';
import { useConfig } from '../../store/reducers/config';
import { modalContext } from '../upgrade-modal/modal.provider';
import { isApple } from '../../helpers/is-apple';

export const FreeFeaturedContent = ({
  freeButExpired,
  onRef,
  isPaused,
  themeClass,
}) => {
  let title: string;
  let subtitle: string;
  let button: string;
  const { setIsVisible } = useContext(modalContext);
  const { platform } = useConfig();
  function openModal(): void {
    setIsVisible(true);
    if (typeof window != 'undefined' && window.document) {
      document.body.style.overflow = 'hidden';
    }
  }
  if (isPaused) {
    title = expiredSignUpTitle();
    subtitle = pausedSignUpSubTitle();
  } else if (freeButExpired) {
    title = expiredSignUpTitle();
    subtitle = expiredSignUpSubTitle();
    button = isApple(platform) ? undefined : upgradeButtonText();
  } else {
    title = freeSignUpTitle();
    subtitle = freeSignUpSubTitle();
    button = freeSignUpButtonText();
  }

  return (
    <div
      data-testid="free-featured-content"
      className={classnames('free-featured-content', themeClass, {
        'free-but-expired': freeButExpired,
      })}
      ref={onRef}
    >
      <div className="image-overlay"></div>
      <div className="content">
        <h1>{title}</h1>
        <p>{subtitle}</p>
        {button && <button onClick={openModal}>{button}</button>}
      </div>
    </div>
  );
};

export default FreeFeaturedContent;
